(() => {
  const productMedia = document.querySelector('.product__media');
  if (!productMedia || productMedia.dataset.majbwrMagnifierWired === 'true') return;

  const primary = productMedia.querySelector('.product__primary-image');
  const galleryMain = primary?.closest('.product__gallery-main');
  const dialog = productMedia.querySelector('[data-product-zoom-dialog]');
  const zoomImage = dialog?.querySelector('.product-zoom__image');
  if (!primary || !galleryMain) return;

  productMedia.dataset.majbwrMagnifierWired = 'true';

  if (!document.getElementById('majbwr-magnifier-styles')) {
    const style = document.createElement('style');
    style.id = 'majbwr-magnifier-styles';
    style.textContent = `
      .product__gallery-main {
        position: relative;
        overflow: hidden;
      }
      .majbwr-magnifier-toggle,
      .majbwr-dialog-magnifier {
        width: 46px;
        height: 46px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        border: 1px solid rgba(255,255,255,.68);
        border-radius: 999px;
        background: rgba(0,0,0,.58);
        color: #fff;
        box-shadow: 0 8px 24px rgba(0,0,0,.22);
        backdrop-filter: blur(8px);
        -webkit-backdrop-filter: blur(8px);
        cursor: pointer;
        -webkit-tap-highlight-color: transparent;
      }
      .majbwr-magnifier-toggle:hover,
      .majbwr-dialog-magnifier:hover,
      .majbwr-magnifier-toggle:focus-visible,
      .majbwr-dialog-magnifier:focus-visible {
        background: rgba(0,0,0,.78);
      }
      .majbwr-magnifier-toggle[aria-pressed="true"],
      .majbwr-dialog-magnifier[aria-pressed="true"] {
        background: rgba(255,255,255,.94);
        color: #111;
        border-color: rgba(0,0,0,.16);
      }
      .majbwr-magnifier-toggle {
        position: absolute;
        top: 16px;
        right: 16px;
        z-index: 18;
      }
      .product__gallery-main.is-magnifying {
        cursor: zoom-out;
      }
      .product__gallery-main.is-magnifying .product__primary-image {
        transform: scale(2.25);
        transform-origin: var(--majbwr-zoom-x, 50%) var(--majbwr-zoom-y, 50%);
        transition: transform .16s ease;
        will-change: transform;
        touch-action: none;
        user-select: none;
        -webkit-user-drag: none;
      }
      .majbwr-dialog-magnifier {
        position: fixed;
        top: 18px;
        right: 74px;
        z-index: 10004;
      }
      [data-product-zoom-dialog].is-magnifying {
        overflow: hidden;
        cursor: zoom-out;
      }
      [data-product-zoom-dialog].is-magnifying .product-zoom__image {
        transform: scale(2.35);
        transform-origin: var(--majbwr-zoom-x, 50%) var(--majbwr-zoom-y, 50%);
        transition: transform .16s ease;
        will-change: transform;
        touch-action: none !important;
        user-select: none;
        -webkit-user-drag: none;
      }
      @media (max-width: 749px) {
        .majbwr-magnifier-toggle,
        .majbwr-dialog-magnifier {
          width: 42px;
          height: 42px;
        }
        .majbwr-magnifier-toggle {
          top: 10px;
          right: 10px;
        }
        .majbwr-dialog-magnifier {
          top: 10px;
          right: 62px;
        }
      }
      @media (prefers-reduced-motion: reduce) {
        .product__gallery-main.is-magnifying .product__primary-image,
        [data-product-zoom-dialog].is-magnifying .product-zoom__image {
          transition: none;
        }
      }
    `;
    document.head.appendChild(style);
  }

  const icon = `
    <svg width="21" height="21" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <circle cx="10.5" cy="10.5" r="6.4" fill="none" stroke="currentColor" stroke-width="1.8"/>
      <path d="M15.3 15.3L21 21" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
      <path d="M10.5 7.5v6M7.5 10.5h6" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>
    </svg>`;

  const clamp = (value, min, max) => Math.min(max, Math.max(min, value));

  const setOrigin = (host, rect, clientX, clientY) => {
    if (!rect.width || !rect.height) return;
    const x = clamp(((clientX - rect.left) / rect.width) * 100, 0, 100);
    const y = clamp(((clientY - rect.top) / rect.height) * 100, 0, 100);
    host.style.setProperty('--majbwr-zoom-x', `${x}%`);
    host.style.setProperty('--majbwr-zoom-y', `${y}%`);
  };

  const mainButton = document.createElement('button');
  mainButton.type = 'button';
  mainButton.className = 'majbwr-magnifier-toggle';
  mainButton.setAttribute('aria-label', 'Magnify product image');
  mainButton.setAttribute('aria-pressed', 'false');
  mainButton.innerHTML = icon;
  galleryMain.appendChild(mainButton);

  const setMainMagnifying = (enabled) => {
    galleryMain.classList.toggle('is-magnifying', enabled);
    mainButton.setAttribute('aria-pressed', enabled ? 'true' : 'false');
    mainButton.setAttribute('aria-label', enabled ? 'Stop magnifying product image' : 'Magnify product image');
    if (!enabled) {
      galleryMain.style.removeProperty('--majbwr-zoom-x');
      galleryMain.style.removeProperty('--majbwr-zoom-y');
    }
  };

  mainButton.addEventListener('click', (event) => {
    event.preventDefault();
    event.stopPropagation();
    setMainMagnifying(!galleryMain.classList.contains('is-magnifying'));
  });

  primary.addEventListener('click', (event) => {
    if (!galleryMain.classList.contains('is-magnifying')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
  }, true);

  galleryMain.addEventListener('pointermove', (event) => {
    if (!galleryMain.classList.contains('is-magnifying')) return;
    setOrigin(galleryMain, galleryMain.getBoundingClientRect(), event.clientX, event.clientY);
  });

  galleryMain.addEventListener('pointerdown', (event) => {
    if (!galleryMain.classList.contains('is-magnifying')) return;
    if (event.target === mainButton || mainButton.contains(event.target)) return;
    setOrigin(galleryMain, galleryMain.getBoundingClientRect(), event.clientX, event.clientY);
  });

  productMedia.querySelectorAll('[data-gallery-thumb]').forEach((thumbnail) => {
    thumbnail.addEventListener('click', () => setMainMagnifying(false), true);
  });

  if (!dialog || !zoomImage) return;

  const dialogButton = document.createElement('button');
  dialogButton.type = 'button';
  dialogButton.className = 'majbwr-dialog-magnifier';
  dialogButton.setAttribute('aria-label', 'Magnify fullscreen product image');
  dialogButton.setAttribute('aria-pressed', 'false');
  dialogButton.innerHTML = icon;
  dialog.appendChild(dialogButton);

  const setDialogMagnifying = (enabled) => {
    dialog.classList.toggle('is-magnifying', enabled);
    dialogButton.setAttribute('aria-pressed', enabled ? 'true' : 'false');
    dialogButton.setAttribute('aria-label', enabled ? 'Stop magnifying fullscreen product image' : 'Magnify fullscreen product image');
    if (!enabled) {
      dialog.style.removeProperty('--majbwr-zoom-x');
      dialog.style.removeProperty('--majbwr-zoom-y');
    }
  };

  dialogButton.addEventListener('click', (event) => {
    event.preventDefault();
    event.stopPropagation();
    setDialogMagnifying(!dialog.classList.contains('is-magnifying'));
  });

  dialog.addEventListener('pointermove', (event) => {
    if (!dialog.classList.contains('is-magnifying')) return;
    if (event.target.closest?.('.product-zoom__nav, [data-product-zoom-close], .majbwr-dialog-magnifier')) return;
    setOrigin(dialog, dialog.getBoundingClientRect(), event.clientX, event.clientY);
  });

  dialog.addEventListener('pointerdown', (event) => {
    if (!dialog.classList.contains('is-magnifying')) return;
    if (event.target.closest?.('.product-zoom__nav, [data-product-zoom-close], .majbwr-dialog-magnifier')) return;
    setOrigin(dialog, dialog.getBoundingClientRect(), event.clientX, event.clientY);
  });

  dialog.addEventListener('touchstart', (event) => {
    if (!dialog.classList.contains('is-magnifying')) return;
    event.stopImmediatePropagation();
  }, { capture: true, passive: true });

  dialog.addEventListener('touchend', (event) => {
    if (!dialog.classList.contains('is-magnifying')) return;
    event.stopImmediatePropagation();
  }, { capture: true, passive: true });

  dialog.querySelectorAll('.product-zoom__nav').forEach((button) => {
    button.addEventListener('click', () => setDialogMagnifying(false), true);
  });

  const observer = new MutationObserver((mutations) => {
    if (mutations.some((mutation) => mutation.type === 'attributes' && mutation.attributeName === 'src')) {
      setDialogMagnifying(false);
    }
  });
  observer.observe(zoomImage, { attributes: true, attributeFilter: ['src'] });

  dialog.addEventListener('close', () => setDialogMagnifying(false));
})();